import { render, staticRenderFns } from "./Qitashezhi.vue?vue&type=template&id=1c162337&scoped=true&"
import script from "./Qitashezhi.vue?vue&type=script&lang=js&"
export * from "./Qitashezhi.vue?vue&type=script&lang=js&"
import style0 from "./Qitashezhi.vue?vue&type=style&index=0&id=1c162337&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c162337",
  null
  
)

export default component.exports